<template>
  <div class="wuxing">
    <div class="search-area">
      <div class="header">
        <span>首页</span>
        <span class="logout" @click="logout">退出登录</span>
      </div>
      <div class="search">
        <van-field v-model="keyword" class="search-input" placeholder="选手搜索" right-icon="search" @click-right-icon="get_list" />
      </div>
      <span class="desc">输入姓名关键字或者编号</span>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="get_list">
      <van-list class="list" v-model="loading" :finished="finished" finished-text="没有更多了" @load="get_list">
        <player v-for="(item, index) in list" :key="index" :data="item"></player>
      </van-list>
    </van-pull-refresh>
    <div class="footer">
      <van-button round block type="info" :to="{ name: 'wuxing_rank', query: { matchid: $route.query.matchid } }">查看榜单</van-button>
    </div>
  </div>
</template>

<script>
import Player from 'components/wuxing/player.vue'
import { judgeLogin, judgeSearch } from '../../libs/api.js'

let timer = null

export default {
  components: { Player },
  data() {
    return {
      judge_info: {},
      // list
      keyword: '',
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
    }
  },
  watch: {
    keyword(val) {
      clearTimeout(timer)
      if (val) {
        timer = setTimeout(() => {
          this.get_list()
        }, 500)
      }
    },
  },
  mounted() {
    const info = localStorage.getItem('judge_info')
    if (!info) {
      this.$router.push({ name: 'wuxing_login', query: this.$route.query })
    } else {
      this.judge_info = JSON.parse(info)
    }

    const keyword = this.$route.query.num

    if (keyword) {
      this.keyword = keyword
    }
  },
  methods: {
    get_list() {
      if (!this.keyword) {
        this.finished = true
        this.loading = false
        this.refreshing = false
        return
      }
      this.loading = true

      judgeSearch({
        judgeid: this.judge_info.judgeid,
        token: this.judge_info.token,
        matchid: this.$route.query.matchid,
        keyword: this.keyword,
      }).then((r) => {
        this.list = []
        this.finished = true
        this.loading = false
        this.refreshing = false
        if (Number(r.status) === 200) {
          this.$nextTick(() => {
            this.list = r.data.list
          })
        }
      })
    },
    // login
    logout() {
      this.$dialog
        .confirm({
          title: '提示',
          message: '确认退出登录吗？',
        })
        .then(() => {
          // on confirm
          localStorage.removeItem('judge_info')
          this.$router.push({ name: 'wuxing_login', query: this.$route.query })
        })
        .catch(() => {
          // on cancel
        })
    },
  },
}
</script>

<style lang="less" scoped>
.wuxing {
  padding-bottom: 80px;
  .search-area {
    background: url(../../assets/BG.png) no-repeat center center/cover;
    height: 238px;
    padding: 150px 50px 0;
    box-sizing: border-box;
    position: relative;
    .header {
      position: absolute;
      top: 0;
      left: 0;
      font-size: 18px;
      color: #fff;
      padding: 12px 10px;
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      width: 100%;
      box-sizing: border-box;
      .logout {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.9);
      }
    }
    .search {
      border-radius: 40px;
      overflow: hidden;
      padding-left: 6px;
      background: #fff;
      box-shadow: 0 5px 17px 0 #1f87ff;
    }
    .desc {
      font-size: 12px;
      color: #afd7fd;
      padding-left: 22px;
    }
  }
  .list {
    padding-top: 20px;
  }
  .footer {
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 8px 50px;
    background: #fff;
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.08);
  }
}
</style>
